import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class DeliveryFormatService {
  async getDeliveryFormats({ search = "", category = "", status = "" }) {
    return (
      await fetchApi.get(
        `${URL}/deliveryformat/list?${category ? "category=" + category : ""}${status ? "&status=" + status : ""}${
          search ? "&search=" + encodeURIComponent(search) : ""
        }`
      )
    ).data;
  }

  async createDeliveryFormat(data) {
    return (await fetchApi.post(`${URL}/deliveryformat`, data)).data;
  }

  async getDeliveryFormat(id) {
    return (await fetchApi.get(`${URL}/deliveryformat/${id}`)).data;
  }

  async updateDeliveryFormat(id, data) {
    return (await fetchApi.patch(`${URL}/deliveryformat/${id}`, data)).data;
  }

  async deleteDeliveryFormat(id) {
    return (await fetchApi.delete(`${URL}/deliveryformat/${id}`)).data;
  }
}
